import React, { Component } from "react";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  Row,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { bindActionCreators } from "redux";
import Swal from "sweetalert2";
import { layout, roles } from "../../../../common/constants";
import {
  DataTable,
  ExportCSV,
  MainLoader,
  TableRowField,
} from "../../../../components";
import { getAll as allStoresExport } from "../../../../service/store";
import {
  deleteStore,
  getStores,
  resetStores,
} from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { exportExcel } from "./excel";

class StoreList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      loadingExport: false,
    };
    this.handleObtainStoresExport = this.handleObtainStoresExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.performGetStores(true);
  }

  componentDidUpdate(prevProps) {
    this.checkStoreDelete(prevProps);
  }
  componentWillUnmount() {
    this.props.resetStores();
  }

  performGetStores(reset = false) {
    const { page, filter } = this.state;
    this.props.getStores({ page, filter, reset });
  }

  async filterStores() {
    await this.setState({ page: 1 });
    this.performGetStores();
  }

  handleInputFilterChange(e) {
    if (e.key === "Enter") {
      this.filterStores();
    }
  }

  async checkStoreDelete(prevProps) {
    if (prevProps.deletedStore == null && this.props.deletedStore != null) {
      toast.success("Tienda eliminada satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetStores();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetStores();
  }

  performDeleteStore(id) {
    Swal({
      title: "Eliminar tienda",
      text: "¿Estás seguro que deseas eliminar la tienda?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.deleteStore(id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  optionsFormatterColumn(cell, row) {
    if (this.props.role == roles.SUPER_ADMIN) {
      return (
        <UncontrolledButtonDropdown>
          <DropdownToggle size="sm" color="primary">
            <i className="fa fa-bars"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/stores/${row.id}/detail`
                )
              }
            >
              <i className="fa fa-eye mr-1"></i> Detalle
            </DropdownItem>
            <DropdownItem
              onClick={() =>
                this.props.history.push(`/administration/stores/${row.id}/edit`)
              }
            >
              <i className="fa fa-edit mr-1"></i> Editar
            </DropdownItem>
            <DropdownItem
              disabled={this.props.deleteLoading}
              onClick={() => this.performDeleteStore(row.id)}
            >
              <i className="fa fa-trash mr-1"></i> Eliminar
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      );
    } else {
      return (
        <Button
          type="button"
          color="primary"
          size="sm"
          onClick={() =>
            this.props.history.push(`/administration/stores/${row.id}/detail`)
          }
        >
          <i className="fa fa-eye"></i>
        </Button>
      );
    }
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.stores}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainStoresExport() {
    this.setState({ loadingExport: true });
    allStoresExport(0, null)
      .then((response) => {
        exportExcel(response.data.data);
      })
      .finally(() => this.setState({ loadingExport: true }));
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "xs",
        text: "Tienda",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="RUC:" value={row.ruc} />
              <TableRowField label="Razón Social:" value={row.businessName} />
              <TableRowField label="Dirección:" value={row.address} />
              <TableRowField label="Teléfono:" value={row.phone} />
            </div>
          );
        },
      },
      columnOption,
    ];

    const columns = [
      {
        dataField: "name",
        text: "Nombre",
      },
      {
        dataField: "ruc",
        text: "RUC",
      },
      {
        dataField: "businessName",
        text: "Razón Social",
      },
      {
        dataField: "address",
        text: "Dirección",
      },
      {
        dataField: "phone",
        text: "Teléfono",
      },
      columnOption,
    ];
    if (this.props.loading) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-bag"></i>Tiendas
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={600}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="8">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterStores()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="4">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainStoresExport}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col md="10">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterStores()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col md="2">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainStoresExport}
                        />
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            {this.props.role == roles.SUPER_ADMIN && (
              <Row className="mb-2">
                <Col>
                  <div className="float-right">
                    <Button
                      color="primary"
                      onClick={() =>
                        this.props.history.push("/administration/stores/add")
                      }
                    >
                      <i className="fa fa-plus mr-1"></i> Nuevo
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery minWidth={layout.SM_MIN_WIDTH}>
                  {this.renderDataTable(columns)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { stores, error, loading, pageSize, total } = state.store.storeList;

  return {
    stores,
    error,
    loading,
    pageSize,
    total,
    deletedStore: state.store.deleteStore.store,
    deleteError: state.store.deleteStore.error,
    deleteLoading: state.store.deleteStore.loading,
    role: selectUserRole(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getStores,
      deleteStore,
      resetStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Store/StoreList/StoreList.js